import { Component, OnInit, inject } from '@angular/core';
import { NgOtpInputModule } from 'ng-otp-input';
import { ProfileDropdownComponent } from '../../../shared/components/profile-dropdown/profile-dropdown.component';
import { Logout } from '@bo/ng-auth';
import { Store } from '@ngxs/store';
import { TermsAccept } from '../../../_interfaces/terms.interface';
import { ClearAppState, SetAppStateFromTermsAcceptedGuard } from '../../../store/app/app.actions';
import { TermsApiService } from '../../../_services/terms-service/terms-api.service';
import { ToastService } from '../../../_services/toast-service/toast.service';
import { ProgressBarService } from '../../../_services/progress-bar-service/progress-bar.service';
import { Router, RouterLink } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { UpdatedSideGraphic } from '../../../store/onboarding/onboarding.actions';

@Component({
  selector: 'app-terms-updated-accept',
  imports: [NgOtpInputModule, ProfileDropdownComponent, RouterLink],
  templateUrl: './terms-updated-accept.component.html',
})
export class TermsUpdatedAcceptComponent implements OnInit {
  readonly store = inject(Store);
  readonly termsApiService = inject(TermsApiService);
  readonly toastService = inject(ToastService);
  readonly progressBarService = inject(ProgressBarService);
  readonly router = inject(Router);

  protected baseUrl = environment.dashboardBaseUrl;

  constructor() {
    this.store.dispatch(new UpdatedSideGraphic('reg5.svg'));
  }

  ngOnInit() {
    this.progressBarService.setHideProgress(true); // Set to true to hide the progress bar
  }

  onLogout(): void {
    this.store.dispatch(new ClearAppState());
    this.store.dispatch(new Logout());
  }

  onAccept(): void {
    const data: TermsAccept = { accept: true };
    this.termsApiService.acceptTermsAll(data).subscribe({
      next: () => {
        this.store.dispatch(SetAppStateFromTermsAcceptedGuard).subscribe({
          next: () => {
            this.router
              .navigate(['/dashboard'])
              .then(() => this.toastService.show(`You have accepted our updated Terms of Use`, 'iconoir-check-circle'));
          },
        });
      },
      error: () => {
        this.toastService.show(`Something went wrong`, 'iconoir-xmark');
      },
    });
  }
}
